import React, { type ReactNode } from "react";
import { HeaderText } from "src/components/v1";

import DashboardHeader from "../DashboardHeader";

export interface UnauthenticatedLayoutProps {
  header: ReactNode;
  children: ReactNode;
}

const UnauthenticatedLayout = ({ header, children }: UnauthenticatedLayoutProps) => (
  <>
    <DashboardHeader />
    <div className="flex flex-col items-center content-center justify-center mt-[140px] max-[600px]:mt-8 max-[600px]:px-8">
      <HeaderText className="font-bold mb-10 max-[600px]:text-[28px] text-center text-black">
        {header}
      </HeaderText>
      <div className="w-[390px] max-[600px]:w-full">{children}</div>
    </div>
  </>
);

export default React.memo(UnauthenticatedLayout);
